import { render, staticRenderFns } from "./AskForPermissionsCard.vue?vue&type=template&id=1288d1ba"
import script from "./AskForPermissionsCard.vue?vue&type=script&lang=js"
export * from "./AskForPermissionsCard.vue?vue&type=script&lang=js"
import style0 from "./AskForPermissionsCard.vue?vue&type=style&index=0&id=1288d1ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports